import autoComplete from "./auto_complete"

window.autoComplete = autoComplete;